<template>
<inertia-head title="Cookiepolicy" />

<div>
    <breadcrumb>
        <breadcrumb-item>
            <inertia-link href="/">Hem</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item :last="true">
            {{ $t('cookies') }}
        </breadcrumb-item>
    </breadcrumb>

    <div class="main container page-content-padding">
        <h1 class="page-heading text-red">{{ $t('cookies') }}</h1>

        <div class="mt-4 underline">Senast uppdaterad: 2021-12-16</div>

        <h4 class="subtitle subtitle-padding">Vad är en cookie?</h4>
        <p class="text-light-w justify-content">
            När vi pratar om cookies på internet menar vi små textfiler som sparas på din dator eller
            enhet, via din webbläsare, när du besöker en webbplats. Informationen i en cookie berättar
            saker för webbplatsen, som till exempel:
        </p>
        <ul class="text-light-w">
            <li>om du besökt webbplatsen tidigare</li>
            <li>om du har ett konto som du valt att förbli inloggad på </li>
            <li>om du har påbörjat en ansökan men inte avslutat den </li>
        </ul>
        <h4 class="subtitle subtitle-padding">Hur använder vi cookies?</h4>
        <p class="text-light-w justify-content">
            Vi använder oss av lokal lagring av data, vilket innebär att olika typer data lagras lokalt på
            din enhet (t.ex. dator, mobiltelefon eller surfplatta) via din webbläsare. En typ av lokal lagring
            av data är cookies. En cookie är en liten textfil som lagras på din enhet (t.ex. dator,
            mobiltelefon eller surfplatta) vilken gör det möjligt för oss att känna igen din webbläsare.
            Cookies innehåller ingen direkt identifierbar information avseende dig (så som namn,
            adress, telefonnummer etc.) utan endast information om din webbläsare och den aktivitet
            som har skett genom webbläsaren. Vi använder oss också av andra liknande tekniker
            såsom pixeltaggar. Dessa är tekniker som kan känna igen cookies och andra identifierare
            och som gör det möjligt för tredje parter att placera cookies i din enhet. I detta dokument
            används termen ”lokal lagring av data” som ett samlingsnamn för cookies, pixeltaggar och
            annan liknande teknik. <br>
            <br>
            Viss lokal lagring av data är nödvändig för att du ska kunna använda Familjekortets tjänst.
            Detta gäller till exempel information om dina inställningar, vilket visar oss hur frågorna ska
            presenteras i din webbläsare. Lokal lagring av data används också för att vi ska kunna
            anpassa våra tjänster så bra som möjligt efter din användning, exempelvis för att lagra vilka
            inställningar som du vill ha vid uppspelning av ljud, för att lagra information om vilken
            videokvalitet som passar din webbläsare och internethastighet och för specialfunktioner
            såsom möjligheten att spara ifyllda uppgifter. Nödvändiga cookies används också för att vi
            ska kunna erbjuda livechatt till dig som besöker Familjekortets hemsida. Vi använder också
            olika mätverktyg som ger oss statistik och analyser avseende beteende på Familjekortets
            hemsida för att vi ska kunna ge dig en personligt anpassad upplevelse. Vidare använder vi
            information vi har samlat in och analyserat för att utveckla och förbättra Familjekortets
            hemsida och för att kontrollera att den fungerar som den ska.
        </p>
        <h4 class="subtitle subtitle-padding">Kan du själv styra användningen av cookies?</h4>
        <p class="text-light-w justify-content container-padding">
            Ja. Du kan hantera cookies i din webbläsare, antingen genom att rensa bort befintliga
            cookies eller genom att förhindra att nya cookies sparas. De flesta webbläsare erbjuder även
            ett anonymt läge som förhindrar att cookies sparas under en viss webbläsarsession. Se din
            webbläsares hjälpavsnitt för ytterligare information. <br>
            <br>
            Kom ihåg att cookies enbart gäller för en enskild webbläsare på en viss enhet. Om du till
            exempel sätter regler för eller raderar cookies på Chrome på din mobiltelefon kommer dessa
            ändringar inte att verkställas i Firefox på din bärbara dator.<br>
            <br>
            Mer information om hur man stänger av cookies finns i instruktionerna till din webbläsare.
        </p>
    </div>
    <inertia-link class="btn btn-danger cookies-button " href="/kampanjer">{{ $t('all_discounts') }}</inertia-link>
    </div>
</template>
